import axios from "api/axios"
import { APIResponse, ConfigWithURLParams } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { LearnerAnalyticsResponse, TimeSpentAnalytics } from "./types"
import { urls } from "./urls"

export default {
  getLearnerAnalytics: async ({
    urlParams,
    params,
  }: ConfigWithURLParams<"learningItemId" | "learningItemType">): Promise<
    APIResponse<LearnerAnalyticsResponse>
  > => {
    try {
      const { learningItemId, learningItemType } = urlParams

      const response = await axios.get<LearnerAnalyticsResponse>(
        urls.getAnalyticsData({
          learningItemId,
          learningItemType: learningItemType as string,
        }),
        { params }
      )
      return formatSuccessResponse(response)
    } catch (error) {
      return formatErrorResponse(error)
    }
  },

  getTimeSpentAnalytics: async ({
    urlParams,
    params,
  }: ConfigWithURLParams<"itemId" | "itemType">): Promise<
    APIResponse<TimeSpentAnalytics>
  > => {
    try {
      const { itemId, itemType } = urlParams

      const response = await axios.get<TimeSpentAnalytics>(
        urls.getTimeSpentAnalytics({
          itemId: itemId,
          itemType: itemType as string,
        }),
        { params }
      )
      return formatSuccessResponse(response)
    } catch (error) {
      return formatErrorResponse(error)
    }
  },
}
